import { render, staticRenderFns } from "./SalesForm.vue?vue&type=template&id=13a338f4"
import script from "./SalesForm.vue?vue&type=script&lang=js"
export * from "./SalesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports